import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Tab, Table, Divider, Button, Icon } from "semantic-ui-react";
import searchSvg from "../../../../assets/svg/search.svg";
import "./ListUsers.scss";
import _ from "lodash";
// import Loader from "./Loader";
// import UserItem from "./UserItem";
// import { useAuth } from "../hooks/useAuth";
// import { useLanguage } from "../hooks/useLanguage";
// import { isAdmin, isMaster, hasPermission } from "../utils/roles";
// import userController from "../controllers/userController";
// import permissionController from "../controllers/permissionController";
import { ErrorAccessDenied } from "../../../../pages/admin/Error";
import { LoadingSpinner } from "../../../Shared";
import { useLanguage } from "../../../../contexts";
import { useAuth } from "../../../../hooks";
import { UserItem } from "../UserItem";
import { Permission, User } from "../../../../api";
import { isAdmin,isMaster, hasPermission } from "../../../../utils/checkPermission";

const userController=new User();
const permissionController=new Permission();

export function ListUsers({ usersActive, usersStatus, reload, onReload, onOpenModal, onOpenInviteModal }) {
  const [users, setUsers] = useState(null);
  const [usersFilter, setUsersFilter] = useState({});
  const [originalUsersByCompany, setOriginalUsersByCompany] = useState({});
  const [permissionsByRole, setPermissionsByRole] = useState([]);

  const { accessToken, user: { role, site, company } } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  // --- Cargar permisos ---
  useEffect(() => {
    (async () => {
      try {
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (err) {
        console.error(err);
        setPermissionsByRole([]);
      }
    })();
  }, [role, accessToken]);

  // --- Cargar usuarios ---
  useEffect(() => {
    (async () => {
      try {
        setUsers(null);
        let response = [];

        if (usersStatus) {
          // Consulta por status (invited / pending)
          if (isAdmin(role) && company) {
            response = await userController.getUsersByCompanyAndStatus(accessToken, company, usersStatus);
          } else if (isMaster(role)) {
            response = await userController.getUsersByStatus(accessToken, usersStatus);
          }
        } else {
          // Consulta clásica por active
          if (isAdmin(role) && company) {
            response = await userController.getUsersByCompany(accessToken, company, usersActive);
          } else if (isMaster(role)) {
            response = await userController.getUsers(accessToken, usersActive);
          }
        }

        const result = response.map(u => ({ ...u, key: u._id }));

        setUsers(result);

        // --- Agrupar por empresa ---
        const NO_COMPANY_KEY = "__no_company__";
        const grouped = result.reduce((acc, user) => {
          const name = user.company?.name || NO_COMPANY_KEY;
          if (!acc[name]) acc[name] = [];
          acc[name].push(user);
          return acc;
        }, {});

        setUsersFilter(grouped);
        setOriginalUsersByCompany(grouped);
      } catch (err) {
        console.error(err);
      }
    })();
  }, [usersActive, usersStatus, reload]);

  if (!users) return <LoadingSpinner />;
  if (users.length === 0) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "1rem 0" }}>
      <span>{t("there_is_no_user")}</span>
      <div style={{ marginRight: "0.5rem" }}>
        {onOpenInviteModal && (
          <Button icon className="add-user-btn" style={{ backgroundColor: "#0E376E", color: "#fff" }} onClick={onOpenInviteModal}>
            <Icon name="mail" />
          </Button>
        )}
        {onOpenModal && (
          <Button icon className="add-user-btn" onClick={onOpenModal}>
            <Icon name="plus" />
          </Button>
        )}
      </div>
    </div>
  );

  // --- Preparar tabs ---
  const companyEntries = Object.entries(usersFilter);
 // --- Preparar panes / tabla ---
let panes = [];
let showTabs = true;

// Si el usuario tiene company -> mostrar solo su empresa sin tabs
if (company) {
  const allUsers = users || [];
  panes = [
    {
      menuItem: null,
      render: () => (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1rem" }}>
            <SearchStandardUser
              dataOrigin={allUsers}
              setData={(filteredUsers) =>
                setUsersFilter({ __admin__: filteredUsers })
              }
              t={t}
            />
            <Button.Group style={{ marginLeft: "auto", marginRight: "0.5rem" }}>
              {onOpenInviteModal && (
                <Button icon className="add-user-btn" style={{ backgroundColor: "#A4C4E0", color: "#fff" }} onClick={onOpenInviteModal}>
                  <Icon name="mail" />
                </Button>
              )}
              {onOpenModal && (
                <Button icon className="add-user-btn" onClick={onOpenModal}>
                  <Icon name="plus" />
                </Button>
              )}
            </Button.Group>
          </div>
          <Divider clearing />
          <Table className="users-table">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{t("name")}</Table.HeaderCell>
                <Table.HeaderCell>{t("lastname")}</Table.HeaderCell>
                <Table.HeaderCell>{t("email")}</Table.HeaderCell>
                {isMaster(role) && <Table.HeaderCell>{t("company")}</Table.HeaderCell>}
                {isAdmin(role) && !site && <Table.HeaderCell>{t("site")}</Table.HeaderCell>}
                <Table.HeaderCell>{t("role")}</Table.HeaderCell>
                <Table.HeaderCell>{t("actions")}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {(usersFilter.__admin__ || allUsers).map(user => (
                <UserItem key={user._id} user={user} onReload={onReload} hideActivate={usersStatus === 'invited'} />
              ))}
            </Table.Body>
          </Table>
        </div>
      )
    }
  ];
  showTabs = false;
} else {
  // Caso normal: varias empresas o empresa sin nombre -> usar tabs
  const companyEntries = Object.entries(usersFilter);
  const NO_COMPANY_KEY = "__no_company__";
  panes = companyEntries.map(([companyName, usersGroup]) => ({
    menuItem: companyName === NO_COMPANY_KEY ? t("no_company") : companyName,
    render: () => (
      <Tab.Pane key={companyName}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1rem" }}>
          <SearchStandardUser
            dataOrigin={originalUsersByCompany[companyName] || []}
            setData={(filteredUsers) =>
              setUsersFilter(prev => ({ ...prev, [companyName]: filteredUsers }))
            }
            t={t}
          />
          <Button.Group style={{ marginLeft: "auto", marginRight: "0.5rem" }}>
            {onOpenInviteModal && (
              <Button icon className="add-user-btn" style={{ backgroundColor: "#0E376E", color: "#fff" }} onClick={onOpenInviteModal}>
                <Icon name="mail" />
              </Button>
            )}
            {onOpenModal && (
              <Button icon className="add-user-btn" onClick={() => onOpenModal(usersGroup[0]?.company?._id || null)}>
                <Icon name="plus" />
              </Button>
            )}
          </Button.Group>
        </div>
        <Divider clearing />
        <Table className="users-table">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t("name")}</Table.HeaderCell>
              <Table.HeaderCell>{t("lastname")}</Table.HeaderCell>
              <Table.HeaderCell>{t("email")}</Table.HeaderCell>
              {isMaster(role) && <Table.HeaderCell>{t("company")}</Table.HeaderCell>}
              {isAdmin(role) && !site && <Table.HeaderCell>{t("site")}</Table.HeaderCell>}
              <Table.HeaderCell>{t("role")}</Table.HeaderCell>
              <Table.HeaderCell>{t("actions")}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {usersGroup.map(user => (
              <UserItem key={user._id} user={user} onReload={onReload} hideActivate={usersStatus === 'invited'} />
            ))}
          </Table.Body>
        </Table>
      </Tab.Pane>
    )
  }));
}


  return (
    <div className="users-list">
      {isMaster(role) || isAdmin(role) || hasPermission(permissionsByRole, role._id, "users", "view") ? (
        showTabs ? (
          <Tab
            panes={panes}
            menu={{ fluid: true, vertical: true }}
            menuPosition="left"
            style={{ marginTop: "16px" }}
          />
        ) : (
          panes[0].render() // mostrar tabla sin tabs
        )
      ) : (
        <ErrorAccessDenied />
      )}
    </div>
  );
}


// -------------------- Buscador --------------------
function SearchStandardUser({ dataOrigin = [], setData, t }) {
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const debouncedFilter = useMemo(
    () => _.debounce(value => {
      const filtered = dataOrigin.filter(user =>
        ["firstname", "lastname", "email"].some(key =>
          user[key]?.toLowerCase().includes(value.toLowerCase())
        )
      );
      setData(filtered);
      setIsLoading(false);
    }, 300),
    [dataOrigin, setData]
  );

  const handleSearchChange = useCallback(
    (e, { value }) => {
      setSearchValue(value);

      if (!value) {
        setData(dataOrigin); // restaurar lista completa
        setIsLoading(false);
        debouncedFilter.cancel();
        return;
      }

      setIsLoading(true);
      debouncedFilter(value);
    },
    [dataOrigin, setData, debouncedFilter]
  );

  return (
    <div className="search-user-wrapper">
      <img src={searchSvg} alt="search" className="search-user-icon" />
      <input
        className="search-user-input"
        placeholder={t("search")}
        value={searchValue}
        onChange={(e) => handleSearchChange(e, { value: e.target.value })}
      />
    </div>
  );
}